/**
 * Shared compare-selection helpers (bead lucky-war-d9b7).
 *
 * One source of truth for the compare cap + URL-param parsing so /branch
 * (?pick=) and /compare (?ids=) can never disagree about how many branches
 * may be compared or how the id list is parsed.
 */

/** Maximum branches / regions in one side-by-side comparison. */
export const MAX_COMPARE_BRANCHES = 6;

/**
 * Parse a comma-separated id-list query param into a de-duplicated,
 * cap-trimmed array. Tolerant of whitespace, empty segments, and dupes
 * (mirrors CompareView's ?ids= handling).
 */
export function parsePickParam(raw: unknown): string[] {
  if (typeof raw !== 'string' || !raw) return [];
  return [...new Set(raw.split(',').map((s) => s.trim()).filter(Boolean))].slice(0, MAX_COMPARE_BRANCHES);
}
